import React from "react";

import { useTranslation } from "react-i18next";

import { Despatch } from "../../../../../../../models/despatch";
import { getLocationArray } from "../../types";
import { DespatchViewDetailsAddressInfos } from "./AddressInfo";
import { Wrapper } from "./styles";

type DespatchViewDetailsProps = {
  despatch: Despatch | null;
};
export const DespatchViewDetails: React.FC<DespatchViewDetailsProps> = (props) => {
  const { despatch } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper container direction="column" data-cy="view-details-container">
      <div data-cy="view-details-address">
        <DespatchViewDetailsAddressInfos
          title={translate("pickup").toLowerCase()}
          locations={getLocationArray(despatch?.originAddress)}
        />
      </div>
      <div data-cy="view-details-address">
        <DespatchViewDetailsAddressInfos
          title={translate("delivery").toLowerCase()}
          locations={getLocationArray(despatch?.destinationAddress)}
        />
      </div>
    </Wrapper>
  );
};
